import materialColors from 'vuetify/es5/util/colors';

export default {
  // Gráfico Whatsapp
  primaryWhatsapp: materialColors.green.lighten2,
  secondaryWhatsapp: materialColors.green.lighten1,
  tertiaryWhatsapp: materialColors.green.darken1,
  // Gráfico Voz
  primaryVoice: materialColors.purple.lighten2,
  secondaryVoice: materialColors.purple.lighten1,
  tertiaryVoice: materialColors.purple.darken1,
  // Gráfico Chat
  primaryChat: materialColors.orange.lighten2,
  secondaryChat: materialColors.orange.lighten1,
  tertiaryChat: materialColors.orange.darken1,
  // Gráfico sem dados
  colorDisabled: materialColors.blueGrey.lighten4,
  colorDisabledIcon: materialColors.blueGrey.lighten4,
  colorDisabledDesc: materialColors.blueGrey.lighten5,
};
